export default __webpack_public_path__ + "static/anna-aa9babe25fc60c63016a84039b0c8e98.jpg";